import { Component, Input } from "@angular/core";
import { CollectionExportPart, UserCollectionExportTaskStatus } from "@apiserver-rest/ponder-tasks-client-base";
import { FormatDateTimePipe } from "@ponder-shared/pipes/format-datetime.pipe";
import { ColorDictionary } from "@ponder-shared/utils/colors";
import { SvgIcon, SvgIconMap } from "@ponder-shared/utils/svgIcons";

@Component({
    selector: "export-collection-result-row",
    imports: [FormatDateTimePipe],
    templateUrl: "./export-collection-result-row.component.html"
})
export class ExportCollectionResultRowComponent {
    @Input({ required: true }) exportStatus!: UserCollectionExportTaskStatus;

    public result?: CollectionExportPart;
    public isExpired: boolean = false;
    public showDetails: boolean = true;
    
    public readonly ColorPending = ColorDictionary.StatusBlue;
    public readonly ColorSuccess = ColorDictionary.StatusGreen;
    public readonly ColorFailed = ColorDictionary.StatusRed;

    public readonly downloadSvgIcon = SvgIconMap.get(SvgIcon.Export)!;

    public constructor() {
        
    }

    public ngOnInit(): void {
        this.result = this.exportStatus.result?.collectionExport;
        
        if (this.result && this.result.artifactExpiresAt) {
            this.isExpired = this.result.artifactExpiresAt.getTime() < (new Date()).getTime();
        }
    }

    public onShowDetailsClicked() {
        if (this.showDetails) {
            this.onHideDetails();
        } else {
            this.onShowDetails();
        }
    }

    private onHideDetails() {
        this.showDetails = false;
    }

    private onShowDetails() {
        this.showDetails = true;
    }
}